import { useQuery } from '@tanstack/react-query';
import {
  fetchProductCategories,
  fetchProductCategory,
  fetchProductSubcategories,
  type ProductCategoryListParams,
} from './request';
import {
  PRODUCT_CATEGORIES_QUERY_KEY,
  PRODUCT_SUBCATEGORIES_QUERY_KEY,
} from './key';

export const useProductCategories = (
  params: ProductCategoryListParams = { page: 1, limit: 100 }
) =>
  useQuery({
    queryKey: [PRODUCT_CATEGORIES_QUERY_KEY, params],
    queryFn: () => fetchProductCategories(params),
  });

export const useProductCategory = (id?: number) =>
  useQuery({
    queryKey: [PRODUCT_CATEGORIES_QUERY_KEY, 'detail', id],
    queryFn: () => fetchProductCategory(id!),
    enabled: !!id,
  });

export const useProductSubcategories = (categoryId?: number, enabled = true) =>
  useQuery({
    queryKey: [PRODUCT_SUBCATEGORIES_QUERY_KEY, categoryId],
    queryFn: () => fetchProductSubcategories(categoryId!),
    enabled: !!categoryId && enabled,
  });
